import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Toolbar, AppBar } from "@material-ui/core";
import { useSelector } from "react-redux";
import clsx from "clsx";

const useStyles = makeStyles(({ palette, ...theme }) => ({
  footer: {
    minHeight: "var(--topbar-height)",
    "@media (max-width: 499px)": {
      display: "table",
      width: "100%",
      minHeight: "auto",
      padding: "1rem 0",
      "& .container": {
        flexDirection: "column !important",
        "& a": {
          margin: "0 0 16px !important",
        },
      },
    },
  },
  appbar: {
    zIndex: 96,
  },
}));

const Footer = () => {
  const classes = useStyles();
  


  return (
    //<ThemeProvider theme={footerTheme}>
      <AppBar color="primary" position="static" className={classes.appbar}>
        <Toolbar className={clsx("flex items-center", classes.footer)}>
          <div className="flex items-center container w-full">
            {/* <a
              href="https://github.com/uilibrary/matx-react"
              target="_blank"
              className="mr-2"
              rel="noopener noreferrer"
            >
              <Button variant="contained">Download Free version</Button>
            </a> */}
            {/* <a href="https://material-ui.com/store/items/matx-pro-react-dashboard-template/">
              <Button variant="contained" color="secondary">
                Get MatX Pro
              </Button>
            </a> */}
            <span className="m-auto"></span>
            <p className="m-0">
              Developed and Powered by <a href="https://guud.company/" target="_blank">GUUD International</a>
            </p>
          </div>
        </Toolbar>
      </AppBar>
  //  </ThemeProvider>
  );
};

export default Footer;
